<template>
  <svg
    class="arrow-svg"
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="{ rotated: rotated }"
  >
    <path d="M2 2L6 6L10 2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" />
  </svg>
</template>

<script>
export default {
  name: "ArrowDown",
  props: {
    rotated: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.arrow-svg {
  transition: transform 0.15s ease;
}
.arrow-svg.rotated {
  transform: rotate(180deg);
}
</style>
